// (async()=>{var e=await import(window.theme.modules.baseComponent);customElements.define("posted-popup",class extends e.default{async render(){window.location.search.includes("?customer_posted=true")&&(await new Promise(e=>{window.theme.modalReady&&e(),document.addEventListener("modalReady",e,{once:!0})}),this._trigerModal())}_trigerModal(){this.trigger("openPopup",{target:"#postedPopup",layout:"small"})}})})();



(async () => {
    var e = await import(window.theme.modules.baseComponent);
    customElements.define("posted-popup", class extends e.default {
        async render() {
          console.log(window.location.search.includes("?contact"));
         if (window.location.search.includes("?contact")){
           window.location.search.includes("?contact") && (await new Promise(e => {
                window.theme.modalReady && e(), document.addEventListener("modalReady", e, {
                    once: !0
                })
            }), this._trigerModal());
         }else{
            window.location.search.includes("?customer_posted=true") && (await new Promise(e => {
                window.theme.modalReady && e(), document.addEventListener("modalReady", e, {
                    once: !0
                })
            }), this._trigerModal())
        }
        }
        _trigerModal() {
            this.trigger("openPopup", {
                target: "#postedPopup",
                layout: "small"
            })
        }
    })
})();